import type { ConvertFormatResponse, FormatOutput, FormatPreset } from '@pulsify/shared/dto'
import { adminBypassHeaders } from '~/app/admin-bypass'
import { api, getAuthToken, unwrap } from '~/shared/lib/rpc'

export const formatConverterApi = {
  async convert(
    businessId: string,
    file: File,
    presets: FormatPreset[],
    output: FormatOutput = 'webp',
    focus = '',
  ): Promise<ConvertFormatResponse> {
    const url = api.api.businesses[':businessId']['ai-studio'].format.$url({
      param: { businessId },
    })
    const formData = new FormData()
    formData.append('file', file)
    formData.append('presets', JSON.stringify(presets))
    formData.append('output', output)
    if (focus.trim()) formData.append('focus', focus.trim())
    const token = await getAuthToken()
    const headers: Record<string, string> = { ...adminBypassHeaders() }
    if (token) headers.Authorization = `Bearer ${token}`
    const res = await fetch(url, { method: 'POST', body: formData, headers })
    return unwrap<ConvertFormatResponse>(res)
  },
}
